import {useState} from 'react';
import Form from '/src/components/form/Form';
import Field from '/src/components/UI/Field/Field';
import TextInput from '/src/components/UI/TextField/TextInput';
import TextArea from '/src/components/UI/TextField/TextArea';
import CheckBox from '/src/components/UI/CheckBox/CheckBox';
import AutoComplete from '/src/components/UI/AutoComplete/AutoComplete.js';
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import  { useModal } from "@ebay/nice-modal-react"
import ChooseFile from '/src/components/UI/ChooseFile/ChooseFile.js';
import Button from "/src/components/UI/Button/Button";
import { useForm } from 'react-hook-form';
import RoleFormTypes from './RoleFormTypes.js';
import roleService from '../../services/roleService.js';
import companyService from '/src/features/administration/company/services/companyService';
import roleImages from './roleImages.js';
import storage from '/src/utils/storage';
import './RoleForm.css';
import Dropdown from '/src/components/UI/DropDown/DropDown.js';
function RoleModalBody({ data, type }) {

	const currentUser = storage('local').get('user');
	const formData = RoleFormTypes[type ? type : "create"];
	const modal = useModal();
	const { onClose } = useModalHelper(modal);
	formData.values = data;
    const [file, setFile] = useState(data?.image);
	const { addRole, updateRole , checkAvailability} = roleService;
	const { getCompaniesAutocomplete } = companyService;
	const [roleAvailable, setRoleAvailable] = useState({ slug: true});

	const { register, setError, clearErrors, handleSubmit, watch, formState: { errors }, formState, setValue, getValues } = useForm({
		mode: "onChange",
		defaultValues: {
			slug: formData.values ? formData.values.slug : "",
			name: formData.values ? formData.values.name : "",
			avatar: formData.values ? formData.values.logo : '',
			company_id: formData.values ? formData.values.company_id : null
			
		}
	});


	const onSubmit = async () => {
		const dataToSend = getValues();
		let formData = new FormData();
		formData.append("slug", dataToSend.slug);
        formData.append("name", dataToSend.name);
        formData.append("avatar", dataToSend.avatar);
		formData.append("company_id", dataToSend.company_id !== undefined ? dataToSend.company_id : null)
		const [response, errors] = type != 'create' ? await updateRole(data.id, formData) : await addRole(formData);
		if (errors != null) {
			console.log(errors)
			return;
		}

		modal.resolve(response)
        onClose();
        return;
	}

	const checkValues = async (title, value) => {
        let dataToSend = [];
        dataToSend[title] = value;
        if (value.length == 0) return;
        let [response, error] = await checkAvailability(dataToSend)
        if (error !== null) {
            console.log(error);
            return;
        }
        let res = roleAvailable;
        res[title] = response.available
        if (data != null && value === data[title]) {
            res[title] = true
        }
        setRoleAvailable({ ...res })
    }

	
	return (
		<Form className="edit-container" onSubmit={handleSubmit(onSubmit)}>
			<Form.Title className="form-title">{formData.title}</Form.Title>
			<Form.Body className="body-editModal-container">
						<div className="roleForm-container">
							<Field label={<span>Name <span className="obligatory_field">*</span> </span>} listLabelClassName="titles-input">
								<TextInput {...register('slug', { required: true , onChange: (e) => checkValues("slug", e.target.value)})} style={errors.slug || roleAvailable.slug == false ? { borderColor: "red" } : {}}  className="text_input_user_form" />
								<span className='error-display'>{errors.slug ? (errors.slug.message ? errors.slug.message : "At least 3 letters, and no specials character") : ""}</span>
							</Field>
						</div>

						<div className="roleForm-container">
							<Field label={<span>Description <span className="obligatory_field">*</span> </span>} listLabelClassName="titles-input">
								<TextArea style={{ height: '40px', width: '85%', ...(errors.name ? { borderColor: "red" } : {}) }} {...register('name', { required: true }) }  ></TextArea>
								<span className='error-display'>{errors.name ? (errors.name.message ? errors.name.message : "the description must have at least 5 characters") : ""}</span>
							</Field>
						</div>

						<div style={{  marginBottom: '25px', display: "flex" ,gap:'4rem' }}>
							<Field label="Badge" listLabelClassName="titles-input" />
							<div style={{ marginLeft: "5%", marginTop: "2%" }}>
								<Dropdown  {...register('avatar')} setValue={setValue} choices={roleImages} defaultChoice={type === 'update' && formData.values && formData.values.logo  ? formData.values.logo : roleImages[0].value} width="195px" ></Dropdown>
							</div>
						</div>
						{ ( currentUser.is_admin) ? (
							<div >
								 <Field label="Organization" />
                        		 <AutoComplete name="company_id" required="true" className="full-width text_input_user_form_role" getItemValue={(name, item) => setValue(name, item.id)} apiCall={getCompaniesAutocomplete} getImageFromItem={(item) => item.logo} placeholder="Choose your organization" value={data ? data?.company?.name : ''} style ={{width:'285px'}}></AutoComplete>
							</div>
						):null}
			</Form.Body>
			<br /><br /><br />
			<Form.Buttons>
				<Button type="submit" label={formData.send} className="validate" disabled={!formState.isValid || !roleAvailable.slug == true} />
			</Form.Buttons>
		</Form >
	)

}

RoleModalBody.defaultProps = {
	data: {},
	type: 'create'
}

export default RoleModalBody;